<template>
  <el-card
    class="detail"
    v-loading="!isLoadForm"
    element-loading-text="数据加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.7)"
  >
    <div class="title">四级信息</div>
    <FormData ref="fistFormRef" :formData="formData" :isReadonly="isReadonly" v-if="isLoadForm" />
    <div class="foot-btn-group">
      <el-button v-if="isReadonly" type="primary" @click="editToggle(false)">修改</el-button>
      <el-button v-if="!isReadonly" type="primary" @click="editToggle(true)">详情</el-button>
      <el-button type="primary" @click="submitBtnClickHandler('submit')">提交</el-button>
      <el-button type="info" @click="backBtnClickHandler">返回</el-button>
    </div>
  </el-card>
</template>

<script>
  import { mapState } from 'vuex';
  import storeMasterAPI from '@/api/storeMasterData';
  import FormData from './components/FormData';
  import storeMixin from './../../storeMixin.js';
  export default {
    name: 'Detail',
    mixins: [storeMixin],
    data() {
      return {
        tableData: [],
        status: 'create',
        batchGenerateData: {},
        requestByList: [],
        isReadonly: true,
        formData: {},
        storageName: '',
        isLoadForm: false,
        currentDate: new Date(),
      };
    },
    methods: {
      // 保存按钮
      saveBtnClickHandler() {
        this.$refs.fistFormRef.validate((formData) => {
          this._postData('save', 'ZT01', 4, formData, []);
        });
      },
      editToggle(flag) {
        console.log(flag);
        this.isReadonly = flag;
      },
      // 提交按钮
      submitBtnClickHandler(type) {
        this.$refs.fistFormRef.validate((formData) => {
          this._postData(type, 'ZT02', 4, formData);
        });
      },

      // 根据id获取数据反填到表单上
      async getFormDataApi(id) {
        const { data } = await this.$axios.get(`${storeMasterAPI.GET_FORM_DATA_BY_ID}/${id}`);
        if (data.code == 0) {
          this.formData = data.data;
          console.log(data.data.storageName, '表单上数据111');
          this.storageName = data.data.storageName;
          this.isLoadForm = true;
        } else {
          console.error('根据id获取表单数据失败');
        }
      },

      // 返回
      backBtnClickHandler() {
        this.$router.go(-1);
      },
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      storageCreatePersonName() {
        return this.userInfo.personName;
      },
      storageCreatePersonNo() {
        return this.userInfo.userCode;
      },
    },
    mounted() {
      if (this.$route.query?.rowId) {
        this.getFormDataApi(this.$route.query?.rowId);
      }
    },
    components: {
      FormData,
    },
  };
</script>

<style lang="scss" scoped>
  .detail {
    background: #fff;
    border-radius: 8px;
    .title {
      font-size: 18px;
      padding: 10px;
      padding-left: 20px;
      font-weight: 700;
    }
    .foot-btn-group {
      margin-top: 30px;
    }
  }
</style>
